import React, { useState, useMemo, useEffect } from 'react';
import {Barchart}  from '../../features/home/BarChart';
import StatCard from '../../features/home/StatCard';
import WelcomeCard from '../../features/home/WelcomeCard';
import TableData from '../../Components/TableData';
import GroupTableData from '../../Components/GroupTableData';
import userImg from '../../Components/assets/images/userImg.png';
import team from '../../Components/assets/images/team.png';
import { Link } from 'react-router-dom';
import { BaseUrl, Admin_Dashboard, User_Today, User_Week, User_month, User_quater, User_Year, Group_Today, Group_Week, Group_month, Group_quater, Group_Year } from '../../services/Url';
import { Loader } from '../../Components/Loader';
import { get } from '../../services/Service';

const Dashboard = () => {
   const [dashData, setDashData] = useState();
   const [isLoading, setIsLoading] = useState(true);

   const data = [
      {
         heading: "Total Registered Users",
         number:dashData?.user_total,
         link:'/users',
      },
      {
         heading: "Total Registered users today",
         number:dashData?.user_today,
         link:'/userstats',
         users: User_Today,
      },
      {
         heading: "Total Registered users this week",
         number:dashData?.user_week,
         link:'/userstats',
         users: User_Week,
      },
      {
         heading: "Total Registered users this month",
         number:dashData?.user_month,
         link:'/userstats',
         users: User_month,
      },
      {
         heading: "Total Registered users this quarter",
         number:dashData?.user_quater,
         link:'/userstats',
         users: User_quater,
      },
      {
         heading: "Total Registered users this year",
         number:dashData?.user_year,
         link:'/userstats',
         users: User_Year,
      }
   ];

   const groupdata = [
      {
         heading: "Total Registered Group",
         number:dashData?.group_total,
         link:'/groups'

      },
      {
         heading: "Total Group Registered Today",
         number:dashData?.group_today,
         link:'/groupstats',
         groups: Group_Today
      },
      {
         heading: "Total Group Registered in this week",
         number:dashData?.group_week,
         link:'/groupstats',
         groups: Group_Week
      },
      {
         heading: "Total Group Registered in this month",
         number:dashData?.group_month,
         link:'/groupstats',
         groups: Group_month
      },
      {
         heading: "Total Group Registered in this Quarter",
         number:dashData?.group_quater,
         link:'/groupstats',
         groups: Group_quater
      },
      {
         heading: "Total Group Registered in this year",
         number:dashData?.group_year,
         link:'/groupstats',
         groups: Group_Year
      },
   ];   

   useEffect(()=>{
      setTimeout(() => {
         get(Admin_Dashboard, setDashData, setIsLoading);
      }, 1500);
   }, []);

  return (
    <div>
      {isLoading ? <Loader /> : ''}
      <WelcomeCard />
      <div className='mt-4'>
         <h2 className='sub-heading'>Users Analytics</h2> 
      </div>
      <div className='row my-4'>
         {data?.map((item, i) => {
            return(
               <div className='col-md-4' key={i}>
               <Link to={item?.link} state={{ url: item?.users }}>
                  <StatCard heading={item?.heading} number={item?.number} img={userImg} />
               </Link>
               </div>
            )
         })}
      </div>
      <div className='row'>
        <div className='col-md-5'>
           <Barchart name="User Stats" chartData={dashData?.user_chart}/>
        </div>
        <div className='col-md-7'>
          <TableData usersArray={ dashData?.user}/>
        </div>
      </div>
      <div className='mt-4'>
        <h2 className='sub-heading'>Groups Analytics</h2>
      </div>
      <div className='row my-4'>
         {groupdata?.map((item, i) => {
            return(
               <div className='col-md-4' key={i}>
                  <Link to={item?.link} state={{ url: item?.groups }}>
                     <StatCard heading={item?.heading} number={item?.number}  img={team}/>
                  </Link>               
               </div>
            )
         })}
      </div>
      <div className='row'>
        <div className='col-md-5'>
           <Barchart name="Group Stats" chartData={dashData?.group_chart}/>
        </div>
        <div className='col-md-7'>
          <GroupTableData groupArray={dashData?.group}/>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
